
import DataTree from './DataTree';

export { default as GHPath } from './GHPath';
export { default as EMFMesh } from './EMFMesh';
export { default as GHMesh } from './GHMesh';
export { default as GHGeometry } from './GHGeometry';
export { default as GenericObject } from './GenericObject';
export { default as Interval } from './Interval';
export { default as GHHandle } from './GHHandle';
export { default as GHSphereGeometry } from './GHSphereGeometry';

const makeMultipleBranches = (dataTrees, outDataTrees) => {
  // if (
  //   dataTrees.includes(NaN) ||
  //   dataTrees.includes(null) ||
  //   dataTrees.find(tree => tree.branches.length <= 0) !== undefined
  // ) {
  //   outDataTrees.push(new DataTree())
  //   return
  // }

  let maxBranchCount = -1;
  let maxBranchIndex = -1;
  for (let i = 0; i < dataTrees.length; i++) {
    if (dataTrees[i].branches.length > maxBranchCount) {
      maxBranchCount = dataTrees[i].branches.length;
      maxBranchIndex = i;
    }
  }

  for (let i = 0; i < dataTrees.length; i++) {
    let outDataTree = new DataTree();
    var dataTree = dataTrees[i];
    if (dataTree.branches.length > 0) {
      for (let j = 0; j < maxBranchCount; j++) {
        let path = dataTrees[maxBranchIndex].paths[j];
        let branch = dataTree.branches[Math.min(j, dataTree.branches.length - 1)];
        if (branch.length > 0) {
          for (let n = 0; n < branch.length; n++) {
            outDataTree.add(branch[n], path);
          }
        } else {
          outDataTree.addEmpty(path);
        }
      }
    }
    outDataTrees.push(outDataTree);
  }
};

const makeMultiplePairs = (dataTrees, outDataTrees, debug = false) => {
  // return if dataTrees has empty data
  // if (
  //   dataTrees.includes(NaN) ||
  //   dataTrees.includes(null) ||
  //   dataTrees.find(tree => tree.branches.length <= 0) !== undefined
  // ) {
  //   // console.log(dataTrees)
  //   outDataTrees.push(new DataTree())
  //   return
  // }

  let maxBranchCount = -1;
  let maxBranchIndex = -1;
  let maxPathCount = -1;
  for (let i = 0; i < dataTrees.length; i++) {
    if (dataTrees[i].branches.length > maxBranchCount) {
      maxBranchCount = dataTrees[i].branches.length;
      maxBranchIndex = i;
    }

    for (let n = 0; n < dataTrees[i].branches.length; n++) {
      let pathCount = dataTrees[i].paths[n].indices.length;

      if (maxPathCount < pathCount) {
        maxPathCount = pathCount;
      }
    }
  }

  let maxListCounts = [];
  let maxListIndexes = [];
  let useMaxPathCount = true;
  for (let i = 0; i < maxBranchCount; i++) {
    maxListCounts.push(-1);
    maxListIndexes.push(-1);

    for (let j = 0; j < dataTrees.length; j++) {
      var dataTree = dataTrees[j];

      let listCount = -1;

      const len = dataTree.branches.length;
      if (i < len) {
        listCount = dataTree.branches[i].length;
      } else if (dataTree.branches.length > 0) {
        listCount = dataTree.branches[dataTree.branches.length - 1].length;
      }

      if (maxListCounts[i] < listCount) {
        maxListCounts[i] = listCount;
        maxListIndexes[i] = i;
      }
    }

    let path = dataTrees[maxBranchIndex].paths[i];

    if (path.indices.length >= maxPathCount) {
      useMaxPathCount = false;
    }
  }

  if (debug) {
    console.log("maxBranchCount:", maxBranchCount)
    console.log("maxBranchIndex:", maxBranchIndex)
    console.log("maxListCounts:", maxListCounts)
    console.log("maxListIndexes:", maxListIndexes)
    console.log("dataTrees:", dataTrees);
  }

  for (let i = 0; i < dataTrees.length; i++) {
    let outDataTree = new DataTree();
    let dataTree = dataTrees[i];

    if (dataTree.branches.length > 0) {
      for (let j = 0; j < maxBranchCount; j++) {
        let path = dataTrees[maxBranchIndex].paths[j].clone();
        if (useMaxPathCount) {
          for (let n = 0; n < maxPathCount - path.indices; n++) {
            path.indices.unshift(0);
          }
        }

        let list = [];

        if (j < dataTree.branches.length) {
          list = dataTree.branches[j];
        } else {
          list = dataTree.branches[dataTree.branches.length - 1];
        }

        let listCount = maxListCounts[maxListIndexes[j]];

        if(list.length === 0){
          outDataTree.addEmpty(path);
          continue;
        }

        for (let t = 0; t < listCount; t++) {
          let val;
          if (t < list.length) {
            val = list[t];
          } else {
            val = list[list.length - 1];
          }

          outDataTree.add(val, path);
        }
      }
    }

    outDataTrees.push(outDataTree);
  }
  if (debug) {
    console.log('________');
  }
};

export {
  DataTree,
  makeMultiplePairs,
  makeMultipleBranches
};



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/geometry/index.js